export default __webpack_public_path__ + "assets/e65fd24a972545fd91b7fcceb80b4632.png";